const $ = require('jquery');
import Swal from "sweetalert2";

$('.js-generatePDF').click(function(e)
{
  // console.log('generate');
  // e.preventDefault();
  let $button = $(this);
  let action = $button.attr('data-action');
  let title = $button.attr('data-success-title');
  let text = $button.attr('data-success-text');

  let $form = $('#js-form');
  $form.attr('target', '').attr('action', action);

  if (!$button.hasClass("is-active"))
  {
    $button.addClass("is-active");
    //$button.attr("disabled","");

    let reportCategory = $button.attr('data-report-category');
    let reportYear = $button.attr('data-report-year');
    let reportName = $button.attr('data-report-name');
    let reportLocale = $button.attr('data-report-locale');
    // console.log(reportCategory, reportYear, reportName, reportLocale);
    dataLayer.push({'event':'interaction', 'reportCategory': reportCategory, 'reportName': reportName, 'reportYear': reportYear, 'reportLocale': reportLocale, 'reportAction': 'generate-report'});

    setTimeout(function()
    {
      $button.removeClass("is-active");
      //$button.attr("disabled", null);

      Swal.fire({
        title: title,
        text: text,
        type: "success",
        confirmButtonText: "Ok",
        preConfirm: () => {
          // console.log('confirm');

          $('.c-list_item_input:checked').each(function () {
            $(this).prop("checked", false);
            $(this).parent('.c-list_item').removeClass('is-active');
          });

          $('.js-previewPDF').prop('disabled','disabled');
          $('.js-generatePDF').prop('disabled','disabled');
        }
      });
    }, 6000);
  }
});